import { render, staticRenderFns } from "./Separator.component.vue?vue&type=template&id=6526da34&scoped=true"
import script from "./Separator.component.vue?vue&type=script&lang=js"
export * from "./Separator.component.vue?vue&type=script&lang=js"
import style0 from "./Separator.component.vue?vue&type=style&index=0&id=6526da34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526da34",
  null
  
)

export default component.exports